import React, { useState, useEffect, useContext, useRef } from 'react';
import { IconContext } from 'react-icons';
import APIService from '@shared/services/api';
import Notify from '@shared/notify';
import { AuthContext } from '@shared/context/AuthContext';
import TextInput from '@shared/component/TextInput';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ModalType } from './transporter';
import CheckValidator from '@shared/checkValidator';
import MultiSelect from '@shared/component/MultiSelect';
import Lists from '@shared/component/Lists';
import ReactStars from 'react-rating-stars-component';
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import { actionsPermissionValidator, ActionValues } from '@utils/static/commonUtils';

interface FormData {
    name: string | null;
    phone: string | null;
    companyname: string | null;
    email: string | null;
    categoryId: number | null;
    itemIds: Array<{ id: number; name: string }> | null;
    categoryData: null;
}

export function OthersMobileUsers() {
    const childRef: any = useRef(null);
    const [errors, setError] = useState<any>({
        name: {
            required: true,
            error: true,
            message: 'Please enter name',
            pattern: /^[A-Za-z\s.]+$/, ///^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g,
            maxLength: 50,
        },
        companyname: {
            required: true,
            error: true,
            message: 'Please enter company name',
            pattern: /^[a-zA-Z][\w&.'\s-]*$/u, ///^[A-Za-z0-9\s]+(([',. -][A-Za-z0-9\s ])?[A-Za-z0-9\s]*)*$/g, ///^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g,
            maxLength: 30,
        },
        phone: {
            required: true,
            error: true,
            message: 'Please enter phone number',
            pattern: /^[6-9]{1}[0-9]{9}$/,
            maxLength: 10,
        },
        categoryId: {
            required: true,
            error: true,
            message: 'Please select category',
        },
        itemIds: {
            required: true,
            error: true,
            message: 'Please select items',
        },
        // email: {
        //     required: false,
        //     error: false,
        //     message: 'Please enter email',
        //     pattern: /\S+@\S+\.\S+/,
        //     maxLength: 50,
        // },
    });

    const { setLoader } = useContext(AuthContext);
    const listRef: any = useRef(null);
    // all items list
    const [usersList, setUsersList] = useState([]);

    const [userData, setUserData] = useState<any>();

    const [ratingData, setRatingData] = useState([]);

    // stores current id item which we are going to edit
    const [id, setId] = useState(null);

    // categories for select box options
    const [categories, setCategories] = useState([]);

    // items for multi select
    const [items, setItems] = useState([]);

    // stores total result count of items
    const [recordCount, setRecordCount] = useState(0);

    const [page, setPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(0);
    const [reviewCount, setReviewCount] = useState(0);
    const recordPerPage: any = 5;

    // stores text input data into state
    const [formData, setFormData] = useState<FormData>({
        name: null,
        phone: null,
        companyname: null,
        categoryId: null,
        itemIds: null,
        email: null,
        categoryData: null,
        // email: null,
    });

    const [isSubmit, setIsSubmit] = useState(false);
    const [edit, setEdit] = useState(false);
    const [showRating, SetShowRating] = useState(false);
    const [showHideModel, setShowHideModel] = useState(false);
    const [modalType, setModalType] = useState<ModalType>(ModalType.EDIT);
    const [columns, setColumns] = useState({
        id: 'ID',
        companyname: 'Company Name',
        name: 'Full Name',
        phone: 'Mobile No.',
        rating: 'Vendor Rating',
        'category.name': 'Category',
        'other_document.gstDoc': 'GST Certificate',
        'other_document.panDoc': 'PAN',
        'other_document.idProof': 'Aadhar',
        status: 'Status',
        // othersAction: 'Action',
        ...(actionsPermissionValidator(location.pathname, ActionValues.Edit) ||
        actionsPermissionValidator(location.pathname, ActionValues.View)
            ? { othersAction: 'Action' }
            : null),
    });
    const [transformedData, setTransformedData] = useState([]);

    /**
     * close or open modal handling
     * @param flag true or false according to modal
     */

    const handleShowRating = (flag: boolean) => {
        SetShowRating(flag);
    };

    const handelModel = (flag: boolean) => {
        try {
            setShowHideModel(flag);
            setIsSubmit(false);
            if (!flag) {
                clearObjData();
                setEdit(false);
                setModalType(ModalType.EDIT);
                errors['companyname'] = {
                    required: true,
                    error: true,
                    message: 'Please enter company name',
                    pattern: /^[\w\s&.'-]+$/u, ///^[A-Za-z0-9\s]+(([',. -][A-Za-z0-9\s ])?[A-Za-z0-9\s]*)*$/g, ///^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g,
                    maxLength: 30,
                };
                setError(errors);
            }
        } catch (error) {}
    };

    function formatDate(dateString) {
        return moment(dateString).format('DD MMM YYYY | hh.mm A');
    }

    // clear state of text input
    const clearObjData = () => {
        setFormData({
            name: null,
            phone: null,
            companyname: null,
            categoryId: null,
            itemIds: null,
            email: null,
            categoryData: null,
        });
        setItems([]);
    };

    const addUser = async () => {
        try {
            const isValid = await CheckValidator(errors, formData);
            setIsSubmit(!isValid);
            // return;

            if (isValid) {
                const data = {
                    name: formData?.name,
                    phone: formData?.phone,
                    categoryId: formData?.categoryId,
                    companyname: formData?.companyname,
                    ...(formData?.itemIds && { itemIds: JSON.stringify(formData?.itemIds) }),
                };
                setLoader(true);
                const addeddata = await APIService.post('user/app/', data, true, true);
                setLoader(false);
                if (addeddata.status === 200) {
                    handelModel(false);
                    Notify('success', 'User created successfully');
                    getAllOtherUsers();
                    listRef.current.clearSearchBox();
                }
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const updateUser = async () => {
        try {
            const isValid = await CheckValidator(errors, formData);
            // return
            setIsSubmit(!isValid);
            if (isValid) {
                const data = {
                    name: formData?.name,
                    // categoryId: formData?.categoryId,
                    // phone: formData?.phone,
                    // companyname: formData.companyname,
                    ...(formData?.itemIds && { itemIds: JSON.stringify(formData?.itemIds) }),
                    email: formData?.email,
                };
                setLoader(true);
                const { status } = await APIService.update('user/update/transporter/profile', id, data, true, true);
                setLoader(false);
                if (status === 200) {
                    errors['companyname'] = {
                        required: true,
                        error: true,
                        message: 'Please enter company name',
                        pattern: /^[A-Za-z0-9\s]+(([',. -][A-Za-z0-9\s ])?[A-Za-z0-9\s]*)*$/g, ///^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g,
                        maxLength: 30,
                    };
                    setError(errors);
                    handelModel(false);
                    Notify('success', 'User updated successfully');

                    getAllOtherUsers();
                    listRef.current.clearSearchBox(true);
                    setEdit(false);
                }
            }
        } catch (err) {
            setLoader(false);
        }
    };

    /**
     * delete users based on ids
     * @param ids id and name object in array
     */
    const getDeleteIds = async (ids: any) => {
        try {
            const data = {
                ids: JSON.stringify(ids),
            };
            setLoader(true);
            const { status } = await APIService.post(`user/deleteAppusers`, data, true, false);
            setLoader(false);
            if (status === 200) {
                Notify('success', 'App user deleted successfully');
            }
            getAllOtherUsers();
        } catch (error) {
            setLoader(false);
            getAllOtherUsers();
        }
    };

    const searchItem = async (value: any, page: any) => {
        try {
            if (!page) {
                page = 1;
                listRef.current.resetPagination();
            }
            const { data } = await APIService.getAll(
                `user/search/appusers?page=${page}&order=desc&sort=createdAt&search=${value}&type=other`,
                true,
                false,
            );
            setUsersList(data.data);
            setRecordCount(data.count);
        } catch (err) {
            setLoader(false);
        }
    };

    const getCategory = async () => {
        try {
            setLoader(true);
            const apiUrl = `category/all/nolimit?type=active`;
            const { data } = await APIService.getAll(apiUrl, true, false);
            setCategories(data.data);
        } catch (err) {
            setLoader(false);
        }
    };

    const getAllOtherUsers = async (page: any = 1) => {
        try {
            setLoader(true);
            const { data } = await APIService.getAll(
                `user/get/allOtherAppUser?page=${page}&sort=createdAt`,
                true,
                false,
            );
            setLoader(false);
            const final = data.data.map(e => ({
                ...e,
                rating: e.rating_appUsers.reduce((sum, curr) => (sum += curr.rating), 0) / e.rating_appUsers.length,
            }));
            setUsersList(final);
            setRecordCount(data?.count || 0);
        } catch (err) {
            setLoader(false);
        }
    };

    useEffect(() => {
        getAllOtherUsers();
        getCategory();
    }, []);

    // from active to inactive or vice versa
    const updateStatus = async (item: any, status: any, id: any, page: any, search: any) => {
        try {
            setLoader(true);
            const { status } = await APIService.update(`user/status/update`, id, undefined, true, false);
            setLoader(false);
            if (status === 200) {
                Notify('success', 'status updated');
                searchItem(search.trim(), page);
            }
        } catch (err) {
            setLoader(false);
        }
    };

    // get user details based on id for updating a user
    const getUserById = async (id: any, type: string, page: any = 1) => {
        try {
            const foundUser: any = usersList.find((user: any) => user.id === id);
            if (foundUser) {
                if (type === 'edit') {
                    delete errors.companyname;
                    errors['email'] = {
                        required: true,
                        error: true,
                        message: 'Please enter email',
                        pattern: /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/,
                    };
                    setError(errors);
                    setEdit(true);
                    handelModel(true);
                    setModalType(ModalType.EDIT);
                    setId(id);
                    setFormData({
                        name: foundUser.name,
                        phone: foundUser.phone,
                        companyname: foundUser.companyname,
                        email: foundUser.email,
                        categoryId: foundUser.category.id,
                        itemIds: foundUser.items,
                        categoryData: { label: foundUser?.category?.name || '', value: foundUser?.category?.id || 0 },
                    });
                    setItems(foundUser.items);
                }
                if (type === 'view') {
                    try {
                        const data = await APIService.getAll(
                            `rating/getRatingByUser?appUserId=${id}&page=${page}&limit=${recordPerPage}`,
                            id,
                            true,
                            false,
                        );
                        setRatingData(data.data.data);

                        setEdit(true);
                        handelModel(true);
                        setModalType(ModalType.VIEW);
                        setId(id);
                        setUserData(foundUser);
                    } catch (error) {}
                }
            }
        } catch (err) {}
    };

    const getPage = async (e: any) => {
        try {
            setPage(e + 1);
            setCurrentPage(e);
            const data = await APIService.getAll(
                `rating/getRatingByUser?appUserId=${userId}&page=${e + 1}&limit=${recordPerPage}`,
                id,
                true,
                false,
            );
            setRatingData(data.data.data);
        } catch (error) {}
    };

    // handle multi select items
    const handleItems = (data: any) => {
        const d = data.map((i: any) => {
            return { id: i.id, name: i.name };
        });
        if (formData) {
            setFormData({ ...formData, itemIds: d });
        }
    };

    // get new value for text input
    const getValue = (e: any) => {
        if (e == null) {
            const data = { ...formData, categoryId: null, itemIds: null };
            setFormData(data);
            return;
        }

        const data = { ...formData, ...e };
        setFormData(data);
        return;
    };

    const getMultiSelectValue = (e: any) => {
        try {
            getValue({ itemIds: e });
            errors['itemIds']['error'] = false;
            setError(errors);
        } catch (error) {}
    };

    return (
        <>
            <div className="container dash-container">
                <div className="dash_bread_box">
                    <ul>
                        <li>Other App Users Type</li>
                    </ul>
                </div>
                <div className="content_body_cover">
                    <Lists
                        ref={listRef}
                        headers={columns}
                        data={usersList}
                        searchItem={searchItem}
                        getDeleteIds={getDeleteIds}
                        updateStatus={updateStatus}
                        getById={getUserById}
                        type="add+delete"
                        handelModel={(e: boolean) => handelModel(e)}
                        callPagination={getAllOtherUsers}
                        addUpdateText="User"
                        recordCount={recordCount}
                    />

                    {showHideModel && (
                        <Modal
                            scrollable={modalType === ModalType.EDIT ? false : true}
                            show={true}
                            onHide={() => handelModel(false)}
                            backdrop="static"
                            keyboard={false}
                            size={'lg'}
                        >
                            <Modal.Header closeButton={!showRating} onClick={clearObjData}>
                                {edit ? (modalType === ModalType.EDIT ? 'Edit User' : 'View User') : 'Add New User'}
                                {showRating == true ? (
                                    <Button
                                        variant="outlined"
                                        className=" outlined_btn"
                                        onClick={() => handleShowRating(false)}
                                    >
                                        Back
                                    </Button>
                                ) : (
                                    ''
                                )}
                            </Modal.Header>
                            <Modal.Body>
                                {modalType === ModalType.EDIT ? (
                                    <div className="material_form_cover">
                                        <form
                                            id="cat-form"
                                            autoComplete="off"
                                            onSubmit={e => {
                                                e.preventDefault();
                                            }}
                                        >
                                            <div className="field_box">
                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <TextInput
                                                            data={{
                                                                type: 'text',
                                                                placeholder: 'Full Name',
                                                                name: 'name',
                                                                id: 'floatingInput',
                                                            }}
                                                            controlName="name"
                                                            isSubmit={isSubmit}
                                                            value={formData.name}
                                                            setValue={(e: any) => getValue(e)}
                                                            errorMsg={errors?.name.message}
                                                            inputProps={errors}
                                                        />
                                                    </div>
                                                    {!edit && (
                                                        <div className="col-sm-6">
                                                            <div className="form-floating">
                                                                <TextInput
                                                                    data={{
                                                                        type: 'text',
                                                                        placeholder: 'Company Name',
                                                                        name: 'companyname',
                                                                        id: 'floatingInput',
                                                                    }}
                                                                    controlName="companyname"
                                                                    isSubmit={isSubmit}
                                                                    value={formData.companyname}
                                                                    setValue={(e: any) => getValue(e)}
                                                                    errorMsg={errors?.companyname.message}
                                                                    inputProps={errors}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                    {!edit && (
                                                        <div className="col-sm-6">
                                                            <div className="form-floating">
                                                                <TextInput
                                                                    data={{
                                                                        type: 'number',
                                                                        placeholder: 'Phone',
                                                                        name: 'phone',
                                                                        id: 'floatingInput',
                                                                    }}
                                                                    controlName="phone"
                                                                    isSubmit={isSubmit}
                                                                    value={formData.phone}
                                                                    setValue={(e: any) => getValue(e)}
                                                                    errorMsg={errors?.phone.message}
                                                                    inputProps={errors}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                    {edit && (
                                                        <>
                                                            <div className="col-sm-6">
                                                                <div className="form-floating no_margin_">
                                                                    <TextInput
                                                                        data={{
                                                                            type: 'text',
                                                                            placeholder: 'email',
                                                                            name: 'email',
                                                                            id: 'floatingInput',
                                                                        }}
                                                                        controlName="email"
                                                                        isSubmit={isSubmit}
                                                                        value={formData.email}
                                                                        setValue={(e: any) => getValue(e)}
                                                                        errorMsg={errors?.email?.message}
                                                                        inputProps={errors}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                    {/* {!edit && ( */}

                                                    <div className="col-sm-6">
                                                        <div className="form-floating ">
                                                            <MultiSelect
                                                                isSingle={true}
                                                                options={categories}
                                                                placeholder={'Select Category*'}
                                                                getMultiSelectValue={(e: any) => {
                                                                    getValue(e);
                                                                    if (e?.value) {
                                                                        const check = categories.find(
                                                                            (category: any) => category.id === e.value,
                                                                        );
                                                                        setItems(check?.items || []);
                                                                        setFormData({
                                                                            ...formData,
                                                                            categoryId: parseInt(e.value, 10),
                                                                        });
                                                                        errors['categoryId']['error'] = false;
                                                                        setError(errors);
                                                                    } else {
                                                                        setItems([]);
                                                                        errors['categoryId']['error'] = true;
                                                                        setError(errors);
                                                                    }
                                                                }}
                                                                displayName="name"
                                                                displayValue="id"
                                                                isClearable={edit ? false : true}
                                                                isDisabled={edit ? true : false}
                                                                setSelectedValues={formData?.categoryData || null}
                                                            />

                                                            {errors?.categoryId?.required &&
                                                                errors?.categoryId?.error &&
                                                                isSubmit && (
                                                                    <div className="text-danger ft-12 error-msg">
                                                                        {' '}
                                                                        {errors?.categoryId.message}
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <>
                                                    {items && items.length > 0 && (
                                                        <div className="row  last_field_no_margin">
                                                            <div className="col-sm-6 ">
                                                                <div className="form-floating">
                                                                    {/* <Multiselect
                                                                        options={items}
                                                                        onSelect={handleItems}
                                                                        onRemove={handleItems}
                                                                        displayValue="name"
                                                                        selectedValues={formData.itemIds}
                                                                        placeholder="Select Items"
                                                                    /> */}

                                                                    <MultiSelect
                                                                        // isSingle={true}
                                                                        ref={childRef}
                                                                        options={items}
                                                                        placeholder={'Select Items'}
                                                                        getMultiSelectValue={getMultiSelectValue}
                                                                        displayName="name"
                                                                        displayValue="id"
                                                                        notSelectDefault={true}
                                                                        // isClearable={edit ? false : true}
                                                                        isDisabled={edit ? true : false}
                                                                        setSelectedValues={formData.itemIds || null}
                                                                    />

                                                                    {errors?.itemIds?.required &&
                                                                        errors?.itemIds?.error &&
                                                                        isSubmit && (
                                                                            <div className="text-danger ft-12">
                                                                                {' '}
                                                                                {errors?.itemIds.message}
                                                                            </div>
                                                                        )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            </div>
                                        </form>
                                    </div>
                                ) : showRating == false ? (
                                    <div className="detail_modal_cover">
                                        <div className="details_box_cover">
                                            <div className="container">
                                                <h3>User Details</h3>
                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <span className="sub_box">Company Name :</span>
                                                                <span className="main_box">
                                                                    {userData && userData?.companyname
                                                                        ? userData.companyname
                                                                        : 'N/A'}
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="sub_box">Mobile No. :</span>
                                                                <span className="main_box">
                                                                    {userData && userData?.phone
                                                                        ? userData.phone
                                                                        : 'N/A'}
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="sub_box">Category :</span>
                                                                <span className="main_box">
                                                                    {userData && userData?.category?.name
                                                                        ? userData.category.name
                                                                        : 'N/A'}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <span className="sub_box">Owner Name :</span>
                                                                <span className="main_box">
                                                                    {userData && userData?.name ? userData.name : 'N/A'}
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="sub_box">Email :</span>
                                                                <span className="main_box">
                                                                    {userData && userData?.email
                                                                        ? userData.email
                                                                        : 'N/A'}
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="sub_box">State :</span>
                                                                <span className="main_box">
                                                                    {/* {userData?.other_document?.state?userData?.other_document?.state:'N/A'} */}
                                                                    {userData?.other_document?.state
                                                                        ? userData.other_document.state
                                                                        : 'N/A'}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <span className="sub_box">City :</span>
                                                                <span className="main_box">
                                                                    {userData && userData?.other_document?.city
                                                                        ? userData.other_document.city
                                                                        : 'N/A'}
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="sub_box">Pincode :</span>
                                                                <span className="main_box">
                                                                    {userData && userData?.other_document?.pincode
                                                                        ? userData.other_document.pincode
                                                                        : 'N/A'}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div className="col-sm-6">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <span className="sub_box">Full Address :</span>
                                                                <span className="main_box">
                                                                    {userData && userData?.other_document?.address
                                                                        ? userData.other_document.address
                                                                        : 'N/A'}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <h3>Item Details</h3>

                                                {userData &&
                                                    userData.items?.length > 0 &&
                                                    userData.items.map((item: any) => {
                                                        return (
                                                            <>
                                                                <div className="row">
                                                                    <div className="col-sm-6">
                                                                        <ul className="detail_list">
                                                                            <li>
                                                                                <span className="sub_box">
                                                                                    Item Name :
                                                                                </span>
                                                                                <span className="main_box">
                                                                                    {item && item?.name
                                                                                        ? item?.name
                                                                                        : 'N/A'}
                                                                                </span>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <ul className="detail_list">
                                                                            <li>
                                                                                <span className="sub_box">
                                                                                    Category :
                                                                                </span>
                                                                                <span className="main_box">
                                                                                    {userData &&
                                                                                    userData?.category?.name
                                                                                        ? userData.category.name
                                                                                        : 'N/A'}
                                                                                </span>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        );
                                                    })}

                                                <hr />
                                                <h3>Documents :</h3>
                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <p className="sub_box">Aadhar No. </p>
                                                                <p className="main_box">
                                                                    {userData && userData?.other_document?.aadharNo
                                                                        ? userData.other_document.aadharNo
                                                                        : 'N/A'}
                                                                </p>
                                                                {userData?.other_document?.idProof ? (
                                                                    <>
                                                                        <p className="sub_box">Uploaded Document </p>
                                                                        <a
                                                                            href={
                                                                                process.env.REACT_APP_API_BASE +
                                                                                userData?.other_document?.idProof
                                                                            }
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                        >
                                                                            <div>
                                                                                {userData?.other_document?.idProof.split(
                                                                                    '.',
                                                                                )[1] != 'png'}
                                                                                {userData?.other_document?.idProof.split(
                                                                                    '.',
                                                                                )[1] != 'jpeg' &&
                                                                                userData?.other_document?.idProof.split(
                                                                                    '.',
                                                                                )[1] != 'jpg' &&
                                                                                userData?.other_document?.idProof.split(
                                                                                    '.',
                                                                                )[1] != 'png' ? (
                                                                                    <div className="previewpdfsignup">
                                                                                        <img
                                                                                            src="./assets/images/pdficon.svg"
                                                                                            className="img-fluid"
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="previewimagesignup">
                                                                                        <img
                                                                                            src={
                                                                                                process.env
                                                                                                    .REACT_APP_API_BASE +
                                                                                                userData?.other_document
                                                                                                    ?.idProof
                                                                                            }
                                                                                            className="img-fluid w-100 h-100"
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                                <div className="previewimagesignuptext">
                                                                                    {userData?.other_document?.idProof
                                                                                        .split('documents')[1]
                                                                                        .slice(12)}
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-sm-4">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <p className="sub_box">PAN No. </p>
                                                                <p className="main_box">
                                                                    {userData && userData?.other_document?.panNo
                                                                        ? userData.other_document.panNo
                                                                        : 'N/A'}
                                                                </p>
                                                                {userData?.other_document?.panDoc ? (
                                                                    <>
                                                                        <p className="sub_box">Uploaded Document </p>
                                                                        <a
                                                                            href={
                                                                                process.env.REACT_APP_API_BASE +
                                                                                userData?.other_document?.panDoc
                                                                            }
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                        >
                                                                            <div>
                                                                                {userData?.other_document?.panDoc.split(
                                                                                    '.',
                                                                                )[1] != 'png'}
                                                                                {userData?.other_document?.panDoc.split(
                                                                                    '.',
                                                                                )[1] != 'jpeg' &&
                                                                                userData?.other_document?.panDoc.split(
                                                                                    '.',
                                                                                )[1] != 'jpg' &&
                                                                                userData?.other_document?.panDoc.split(
                                                                                    '.',
                                                                                )[1] != 'png' ? (
                                                                                    <div className="previewpdfsignup">
                                                                                        <img
                                                                                            src="./assets/images/pdficon.svg"
                                                                                            className="img-fluid"
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="previewimagesignup">
                                                                                        <img
                                                                                            src={
                                                                                                process.env
                                                                                                    .REACT_APP_API_BASE +
                                                                                                userData?.other_document
                                                                                                    ?.panDoc
                                                                                            }
                                                                                            className="img-fluid w-100 h-100"
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                                <div className="previewimagesignuptext">
                                                                                    {userData?.other_document?.panDoc
                                                                                        .split('documents')[1]
                                                                                        .slice(12)}
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-sm-4">
                                                        <ul className="detail_list">
                                                            <li>
                                                                <p className="sub_box">GST Certificate No.</p>
                                                                <p className="main_box">
                                                                    {userData && userData?.other_document?.gstNo
                                                                        ? userData.other_document.gstNo
                                                                        : 'N/A'}
                                                                </p>
                                                                {userData?.other_document?.gstDoc ? (
                                                                    <>
                                                                        <p className="sub_box">Uploaded Document </p>
                                                                        <a
                                                                            href={
                                                                                process.env.REACT_APP_API_BASE +
                                                                                userData?.other_document?.gstDoc
                                                                            }
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                        >
                                                                            <div>
                                                                                {userData?.other_document?.gstDoc.split(
                                                                                    '.',
                                                                                )[1] != 'png'}
                                                                                {userData?.other_document?.gstDoc.split(
                                                                                    '.',
                                                                                )[1] != 'jpeg' &&
                                                                                userData?.other_document?.gstDoc.split(
                                                                                    '.',
                                                                                )[1] != 'jpg' &&
                                                                                userData?.other_document?.gstDoc.split(
                                                                                    '.',
                                                                                )[1] != 'png' ? (
                                                                                    <div className="previewpdfsignup">
                                                                                        <img
                                                                                            src="./assets/images/pdficon.svg"
                                                                                            className="img-fluid"
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="previewimagesignup">
                                                                                        <img
                                                                                            src={
                                                                                                process.env
                                                                                                    .REACT_APP_API_BASE +
                                                                                                userData?.other_document
                                                                                                    ?.gstDoc
                                                                                            }
                                                                                            className="img-fluid w-100 h-100"
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                                <div className="previewimagesignuptext">
                                                                                    {userData?.other_document?.gstDoc
                                                                                        .split('documents')[1]
                                                                                        .slice(12)}
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    {userData?.other_document?.otherDoc ? (
                                                        <div className="col-sm-4">
                                                            <ul className="detail_list">
                                                                <li>
                                                                    <p className="sub_box">Other</p>

                                                                    {userData?.other_document?.otherDoc ? (
                                                                        <>
                                                                            <p className="sub_box">
                                                                                Uploaded Document{' '}
                                                                            </p>
                                                                            <a
                                                                                href={
                                                                                    process.env.REACT_APP_API_BASE +
                                                                                    userData?.other_document?.otherDoc
                                                                                }
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                            >
                                                                                <div>
                                                                                    {userData?.other_document?.otherDoc.split(
                                                                                        '.',
                                                                                    )[1] != 'png'}
                                                                                    {userData?.other_document?.otherDoc.split(
                                                                                        '.',
                                                                                    )[1] != 'jpeg' &&
                                                                                    userData?.other_document?.otherDoc.split(
                                                                                        '.',
                                                                                    )[1] != 'jpg' &&
                                                                                    userData?.other_document?.otherDoc.split(
                                                                                        '.',
                                                                                    )[1] != 'png' ? (
                                                                                        <div className="previewpdfsignup">
                                                                                            <img
                                                                                                src="./assets/images/pdficon.svg"
                                                                                                className="img-fluid"
                                                                                            />
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className="previewimagesignup">
                                                                                            <img
                                                                                                src={
                                                                                                    process.env
                                                                                                        .REACT_APP_API_BASE +
                                                                                                    userData
                                                                                                        ?.other_document
                                                                                                        ?.otherDoc
                                                                                                }
                                                                                                className="img-fluid w-100 h-100"
                                                                                            />
                                                                                        </div>
                                                                                    )}
                                                                                    <div className="previewimagesignuptext">
                                                                                        {userData?.other_document?.otherDoc
                                                                                            .split('documents')[1]
                                                                                            .slice(12)}
                                                                                    </div>
                                                                                </div>
                                                                            </a>
                                                                        </>
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>

                                                {userData && userData.rating > 0 && (
                                                    <div className="detail_modal_cover">
                                                        <h3>Rating & Reviews</h3>
                                                        <div className="row">
                                                            <div style={{ display: 'flex' }}>
                                                                <>
                                                                    <ReactStars
                                                                        count={5}
                                                                        value={userData.rating}
                                                                        size={15}
                                                                        isHalf={true}
                                                                        emptyIcon={
                                                                            <i
                                                                                className="fa fa-star"
                                                                                style={{ color: 'green' }}
                                                                            ></i>
                                                                        }
                                                                        halfIcon={
                                                                            <i
                                                                                className="fa fa-star-half-alt"
                                                                                style={{ color: 'white' }}
                                                                            ></i>
                                                                        }
                                                                        fullIcon={
                                                                            <i
                                                                                className="fa fa-star"
                                                                                style={{ color: 'white' }}
                                                                            ></i>
                                                                        }
                                                                        activeColor="#FFA800"
                                                                        edit={false}
                                                                    />

                                                                    {`(${userData.rating.toFixed(1)})`}
                                                                    {'| Total' +
                                                                        ' ' +
                                                                        userData?.rating_appUsers?.length +
                                                                        ' Reviews'}
                                                                </>
                                                            </div>

                                                            <div className="rating_box_cover">
                                                                {ratingData.slice(0, 2).map((data, index) => (
                                                                    <div className="rating_item" key={index}>
                                                                        <div className="rating_text">
                                                                            <ul className="loc_box_cover">
                                                                                <li>
                                                                                    <div className="loc_box">
                                                                                        {data?.bid?.demands_other
                                                                                            ?.category?.name && (
                                                                                            <span className="item">
                                                                                                {
                                                                                                    data.bid
                                                                                                        .demands_other
                                                                                                        .category.name
                                                                                                }
                                                                                            </span>
                                                                                        )}
                                                                                        {data?.bid?.demands_other
                                                                                            ?.quantity && (
                                                                                            <span className="item">
                                                                                                {
                                                                                                    data.bid
                                                                                                        .demands_other
                                                                                                        .quantity
                                                                                                }
                                                                                                {data.bid.demands_other
                                                                                                    .itemUnit &&
                                                                                                    `(${data.bid.demands_other.itemUnit})`}
                                                                                            </span>
                                                                                        )}
                                                                                        {data?.bid
                                                                                            ?.actualDeliveryDate && (
                                                                                            <span className="item">
                                                                                                {formatDate(
                                                                                                    data.bid
                                                                                                        .actualDeliveryDate,
                                                                                                )}
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                </li>
                                                                            </ul>
                                                                            <ReactStars
                                                                                count={5}
                                                                                value={data?.rating}
                                                                                size={15}
                                                                                isHalf={true}
                                                                                emptyIcon={
                                                                                    <i
                                                                                        className="fa fa-star"
                                                                                        style={{ color: 'green' }}
                                                                                    ></i>
                                                                                }
                                                                                halfIcon={
                                                                                    <i
                                                                                        className="fa fa-star-half-alt"
                                                                                        style={{ color: 'white' }}
                                                                                    ></i>
                                                                                }
                                                                                fullIcon={
                                                                                    <i
                                                                                        className="fa fa-star"
                                                                                        style={{ color: 'white' }}
                                                                                    ></i>
                                                                                }
                                                                                activeColor="#FFA800"
                                                                                edit={false}
                                                                            />
                                                                            {data.remark && <p>{data.remark}</p>}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                                {ratingData.length > 2 ? (
                                                                    <a
                                                                        className="btn custom_btn full_btn"
                                                                        onClick={() => handleShowRating(true)}
                                                                    >
                                                                        View All
                                                                    </a>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="detail_modal_cover no_gap_detail_modal_cover">
                                            <h3>Rating & Reviews</h3>
                                            <div className="row">
                                                <div style={{ display: 'flex' }}>
                                                    <>
                                                        <ReactStars
                                                            count={5}
                                                            value={userData.rating}
                                                            size={15}
                                                            isHalf={true}
                                                            emptyIcon={
                                                                <i
                                                                    className="fa fa-star"
                                                                    style={{ color: 'green' }}
                                                                ></i>
                                                            }
                                                            halfIcon={
                                                                <i
                                                                    className="fa fa-star-half-alt"
                                                                    style={{ color: 'white' }}
                                                                ></i>
                                                            }
                                                            fullIcon={
                                                                <i
                                                                    className="fa fa-star"
                                                                    style={{ color: 'white' }}
                                                                ></i>
                                                            }
                                                            activeColor="#FFA800"
                                                            edit={false}
                                                        />

                                                        {`(${userData.rating.toFixed(1)})`}
                                                        {'| Total' +
                                                            ' ' +
                                                            userData?.rating_appUsers?.length +
                                                            ' Reviews'}
                                                    </>
                                                </div>

                                                <div className="rating_box_cover">
                                                    {ratingData.map((data, index) => (
                                                        <div className="rating_item" key={index}>
                                                            <div className="rating_text">
                                                                <ul className="loc_box_cover">
                                                                    <li>
                                                                        <div className="loc_box">
                                                                            {data?.bid?.demands_other?.category
                                                                                ?.name && (
                                                                                <span className="item">
                                                                                    {
                                                                                        data.bid.demands_other.category
                                                                                            .name
                                                                                    }
                                                                                </span>
                                                                            )}
                                                                            {data?.bid?.demands_other?.quantity && (
                                                                                <span className="item">
                                                                                    {data.bid.demands_other.quantity}{' '}
                                                                                    {data.bid.demands_other.itemUnit &&
                                                                                        `${data.bid.demands_other.itemUnit}`}
                                                                                </span>
                                                                            )}
                                                                            {data?.bid?.actualDeliveryDate && (
                                                                                <span className="item">
                                                                                    {formatDate(
                                                                                        data.bid.actualDeliveryDate,
                                                                                    )}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                                <ReactStars
                                                                    count={5}
                                                                    value={data?.rating}
                                                                    size={15}
                                                                    isHalf={true}
                                                                    emptyIcon={
                                                                        <i
                                                                            className="fa fa-star"
                                                                            style={{ color: 'green' }}
                                                                        ></i>
                                                                    }
                                                                    halfIcon={
                                                                        <i
                                                                            className="fa fa-star-half-alt"
                                                                            style={{ color: 'white' }}
                                                                        ></i>
                                                                    }
                                                                    fullIcon={
                                                                        <i
                                                                            className="fa fa-star"
                                                                            style={{ color: 'white' }}
                                                                        ></i>
                                                                    }
                                                                    activeColor="#FFA800"
                                                                    edit={false}
                                                                />
                                                                {data.remark && <p>{data.remark}</p>}
                                                            </div>
                                                        </div>
                                                    ))}

                                                    {ratingData?.length > 0 && reviewCount > 1 && (
                                                        <div className="pageApp">
                                                            <p>
                                                                Showing {(page - 1) * recordPerPage + 1} to{' '}
                                                                {Math.min(page * recordPerPage, reviewCount)} of{' '}
                                                                <span style={{ fontWeight: 600 }}>{reviewCount}</span>{' '}
                                                                entries
                                                            </p>
                                                            <ReactPaginate
                                                                forcePage={currentPage}
                                                                containerClassName={'pagination'}
                                                                activeClassName={'active'}
                                                                pageClassName={'page-item'}
                                                                onPageChange={(event: any) => getPage(event.selected)}
                                                                breakLabel="..."
                                                                pageCount={Math.ceil(reviewCount / recordPerPage)}
                                                                previousLabel={
                                                                    <IconContext.Provider
                                                                        value={{ color: '#B8C1CC', size: '36px' }}
                                                                    >
                                                                        Back
                                                                    </IconContext.Provider>
                                                                }
                                                                nextLabel={
                                                                    <IconContext.Provider
                                                                        value={{ color: '#B8C1CC', size: '36px' }}
                                                                    >
                                                                        Next
                                                                    </IconContext.Provider>
                                                                }
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                {modalType === ModalType.EDIT && (
                                    <>
                                        <Button
                                            variant="secondary"
                                            className="btn dark_btn custom_btn"
                                            onClick={edit ? updateUser : addUser}
                                        >
                                            {edit ? 'Update' : 'Add'}
                                        </Button>
                                        <Button
                                            variant="default"
                                            className="btn custom_btn border_btn with_icon"
                                            onClick={() => handelModel(false)}
                                        >
                                            Cancel
                                        </Button>
                                    </>
                                )}
                            </Modal.Footer>
                        </Modal>
                    )}
                </div>
            </div>
        </>
    );
}
